import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

  connect() { }

  loginKakao(event) {
    event.preventDefault()

    const key = event.params.key
    const state = event.params.state
    const redirectUri = event.params.redirectUri
    Kakao.init(key)
    console.log(`Kakao.isInitialized() : ${Kakao.isInitialized()}`)
    Kakao.Auth.authorize({
      'redirectUri' : redirectUri
      , 'state' : state
    });
  }

  getCookie(name) {
    var parts = document.cookie.split(name + '=');
    if (parts.length === 2) { return parts[1].split(';')[0]; }
  }
}
